export enum ComponentType {
    PI = 'pi',
    HI = 'hi',
}
